import React from 'react';
import SeoToolPage from './SeoToolPage';

export default function FindClothesByPicture() {
  return <SeoToolPage pageKey="/find-clothes-by-picture" />;
}
